import { CreateCustomerRequest } from "@/models/api/CreateCustomerRequest";
import { LoginRequest } from "@/models/api/LoginRequest";
import { LoginResponse } from "@/models/api/LoginResponse";
import { User } from "@/models/www/store/User";
import baseApi from "./api.service";

const userService = {
	login(loginRequest: LoginRequest): Promise<User> {
		return new Promise((resolve, reject) => {
			baseApi.post<LoginResponse>("customer/login", loginRequest)
				.then(resp => resolve(new User(resp)))
				.catch(err => reject(err))
		})
	},
	agentLogin(loginRequest: LoginRequest): Promise<User> {
		return new Promise((resolve, reject) => {
			baseApi.post<LoginResponse>("agent/login", loginRequest)
				.then(resp => resolve(new User(resp)))
				.catch(err => reject(err))
		})
	},
	customerExist(email: string): Promise<boolean> {
		return new Promise((resolve, reject) => {
			baseApi.post<boolean>("customer/exist", { email: email })
				.then(resp => resolve(resp))
				.catch(err => reject(err))
		})
	},
	create(customer: CreateCustomerRequest): Promise<User> {
		return new Promise((resolve, reject) => {
			baseApi.post<LoginResponse>("customer/create", customer)
				.then(resp => resolve(new User(resp)))
				.catch(err => reject(err))
		})
	},
	forgotPassword(email: string, url: string): Promise<boolean> {
		return new Promise((resolve, reject) => {
			baseApi.post<boolean>("customer/password/forgot", { email, resetUrl: url })
				.then(resp => resolve(resp))
				.catch(err => reject(err))
		})
	},
	validateResetToken(id: string): Promise<boolean> {
		return new Promise((resolve, reject) => {
			baseApi.get<boolean>(`customer/password/validate/${id}`)
				.then(resp => resolve(resp))
				.catch(err => reject(err))
		})
	},
	resetPassword(token: string, password: string, passwordConfirm: string): Promise<boolean> {
		return new Promise((resolve, reject) => {
			baseApi.post<boolean>(`customer/password/reset/${token}`, { password, confirm: passwordConfirm })
				.then(resp => resolve(resp))
				.catch(err => reject(err))
		})
	},
	logout(): Promise<void> {
		return baseApi.get<void>('logout', {});
	}
}

export default userService;